import { dateWithoutHour, isWeekend } from "../../functions";
import { WeeklyUserPlanningTimeSlot } from "./WeeklyUserPlanningTimeSlot";

const HOUR_WIDTH = 100 / 24;

const padTwo = (value) => String(value).padStart(2, "0");

const formatBadgeageTime = (date) => `${padTwo(date.getHours())}h${padTwo(date.getMinutes())}`;

const buildBadgeageTitle = (badgeage, date) => {
    const lines = [formatBadgeageTime(date)];
    const badgeuseName = badgeage?.badgeuse?.name;
    if (badgeuseName) lines.push(badgeuseName);
    const remarks = badgeage?.remarks ?? badgeage?.badgeuse?.remarks;
    if (remarks) lines.push(remarks);
    return lines.join("\n");
};

export const WeeklyUserPlanningDay = (props) => {
    const { datePlanning, timeSlots, selectedTimeSlots, isPublicHoliday, dayLabel, dayBadgeages = [] } = props;
    const options = {
        weekday: 'short',
        day: 'numeric',
        month: 'short'
    }
    const dateString = new Intl.DateTimeFormat('default', options).format(datePlanning);
    const columns = [...new Array(24)].map((val, index) => (index + 1) % 24);

    function handleClickDate(val, ctrlKey) {
        props.onClickDate(val, ctrlKey);
    };

    function handleClickTimeSlots(tsId, ctrlKey) {
        props.onClickTimeSlots(tsId, ctrlKey);
    };

    return (
        <div className={"w-full relative p-0 flex " + (datePlanning.getDay() === 0 ? "mb-3" : "mb-px")}>
            <div className="flex h-12 relative py-1 text-xs w-1/12 bg-slate-100 place-items-center border cursor-pointer hover:shadow-sm" onClick={(e => { e.preventDefault(); handleClickDate(datePlanning, e.ctrlKey) })}>
                <span className={"w-full text-center whitespace-pre " + (isPublicHoliday === true ? "text-red-500" : "text-slate-700")}>{dateString}{dayLabel ? "\n" + dayLabel : ""}</span>
            </div>
            <div key={datePlanning} className={"h-12 relative flex text-center text-xm align-top w-11/12 " + (isWeekend(datePlanning) ? "bg-green-50" : "bg-white")}>
                {columns.map((col, idx) =>
                    <div key={idx} className={"w-[4.16667%] border-t border-r border-b"}></div>
                )}
                {timeSlots && timeSlots.map((timeSlot, index) =>
                    <WeeklyUserPlanningTimeSlot
                        key={index}
                        timeSlot={timeSlot}
                        date={dateWithoutHour(datePlanning)}
                        onClickTimeSlots={handleClickTimeSlots}
                        selected={selectedTimeSlots.includes(timeSlot.id)}
                    />
                )}
                {dayBadgeages.map((badgeage, index) => {
                    if (!badgeage?.badged_at) return null;
                    const badgedAt = new Date(badgeage.badged_at);
                    if (Number.isNaN(badgedAt.getTime())) return null;
                    const leftPercent = (badgedAt.getHours() + badgedAt.getMinutes() / 60) * HOUR_WIDTH;
                    return (
                        <div
                            key={badgeage.id ?? `${badgeage.badged_at}-${index}`}
                            title={buildBadgeageTitle(badgeage, badgedAt)}
                            className="absolute top-0 h-full w-px bg-app-primary pointer-events-auto z-10"
                            style={{ left: `${leftPercent}%` }}
                        >
                            <span className="absolute -top-1 left-1/2 -translate-x-1/2 w-1.5 h-1.5 rounded-full bg-app-primary shadow-sm" />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
